import { styled } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

export const ErrorIconStyled = styled(ErrorOutlineIcon)(({ theme }) => ({
  color: `${theme.palette.error.main} !important`,
  width: 30,
  height: 30,
  marginLeft: theme.spacing(2),
}));
